// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import HttpService from 'src/lib/HttpService';
const DEFAULT_SEND_USER_FEEDBACK_URL = 'feedback';

export default {
    async saveUserFeedback(request: any) {
        const response = await HttpService.proxiedApiCall({
            requestUrl: `${DEFAULT_SEND_USER_FEEDBACK_URL}`,
            type: 'post',
            body: request,
        });
        return response;
    },
};
